








/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import CitySection from '@/client/components/CitySection.vue';
import Contact from '@/client/components/Contact.vue';
import GetInTouch from '@/client/components/GetInTouch.vue';
import PassionsSection from '@/client/components/PassionsSection.vue';
import BasicHeader from '@/client/components/core/BasicHeader.vue';
// @ts-ignore
import { FullBgCard } from '@/client/components/_theme';
import { ImageStrings } from '@/server/types';
import * as Constants from '@/client/components/constants';

@Component({
  components: {
    CitySection,
    FullBgCard,
    Contact,
    GetInTouch,
    PassionsSection,
    BasicHeader,
  },
})
export default class Shrimp extends Vue {
  Constants = Constants;
  image: string = require('@/client/assets/images/landscape-1.jpg');
  images: any =  {
    fullBgImages: [
      require('@/client/assets/images/landscape-2.jpg'),
      require('@/client/assets/images/landscape-3.jpg'),
    ],
    passionImages: {
      image1: require('@/client/assets/images/landscape-4.jpg'),
      image2: require('@/client/assets/images/landscape-5.jpg'),
      image3: require('@/client/assets/images/landscape-6.jpg'),
      image4: require('@/client/assets/images/landscape-7.jpg'),
      image5: require('@/client/assets/images/landscape-8.jpg'),
      image6: require('@/client/assets/images/landscape-1.jpg'),
    },
  };
}
